import { insertPoint } from 'prosemirror-transform';
import { TextSelection } from 'prosemirror-state';
import { SFNodeType } from '@sciflow/schema';

// The outline drags a placeholder character along so the browser has
// something to render while the drag is in flight (see the drag start
// handler that builds the dragged HTML). That placeholder is not part of
// the reference: the link/xref node's `text*` content exists so an
// imported source label can travel with the node, not for a drag
// placeholder, and the schema permits the node to carry no text at all.
// Build the node from attrs only so the placeholder can never end up
// inside the document, and therefore never leak into an export.
export const insertOutline = (attrs) => {
    return (state, dispatch): boolean => {
        const insertAt = insertPoint(state.doc, state.selection.from, state.schema.nodes.link);
        if (insertAt === null) {
            return false;
        }

        if (dispatch) {
            const tr = state.tr;
            tr.insert(
                state.selection.to,
                state.schema.node(SFNodeType.link,
                    { type: attrs.type, href: attrs.href }
                ));
            tr.setSelection(TextSelection.create(tr.doc, state.selection.to + 1));
            dispatch(tr);
        }
        return true;
    };
};
